import ValueGrid from "components/grid/value-grid";
import Block from "components/layout/block";
import { parse } from "lib/locale";
import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { EntityCollection } from "models/list-user-entity-collection";
import { FunctionComponent, useEffect, useState } from "react";
import {
  userDoGetEntityCollections,
  userDoPostEntityCollection,
} from "services/user/entity-collection";
import { userDoGetListEntityFields } from "services/user/list-entity-field";
import { useLocale } from "stores/hooks/locale";

interface SingleSummaryProps {
  listUuid: string;
  listEntity: ListEntity;
}

const SingleSummary: FunctionComponent<SingleSummaryProps> = ({
  listUuid,
  listEntity,
}) => {
  const locale = useLocale();
  const [listEntityFields, toggleListEntityFields] = useState<
    ListEntityField[] | undefined
  >(undefined);
  const [entityCollection, toggleEntityCollection] = useState<
    EntityCollection | undefined
  >(undefined);

  useEffect(() => {
    const fetch = async () => {
      const listEntityFields = await userDoGetListEntityFields(
        listUuid,
        listEntity.uuid,
      );
      toggleListEntityFields(listEntityFields);

      // fetch entityCollections and create a new one, if non exists
      const entityCollections = await userDoGetEntityCollections(
        listEntity.uuid,
      );
      let ec = entityCollections[0];
      if (!ec) {
        ec = await userDoPostEntityCollection(listEntity.uuid, []);
      }
      toggleEntityCollection(ec);
    };
    fetch();
  }, []);

  if (!listEntityFields || !entityCollection) {
    return null;
  }

  return (
    <Block title={parse(listEntity.name, locale)}>
      <ValueGrid
        listEntityFields={listEntityFields}
        entityCollections={[{ ...entityCollection }]}
      />
    </Block>
  );
};

export default SingleSummary;
